/* eslint-disable max-classes-per-file */

export class TopDestinationCardItemClassInterface {
  name: string;

  img: string;

  value: string;

  path: string;

  destinationId: string;

  destinationType: string;

  constructor(data: any) {
    this.name = data.name || "";
    this.img = data.img || "";
    this.value = data.value || "";
    this.path = data.path || "";
    this.destinationId = data.destinationId || "";
    this.destinationType = data.destinationType || "";
  }
}

export class ResponseExperienceTopDestinationInterface {
  data: TopDestinationCardItemClassInterface[];

  status: string;

  constructor(data: any) {
    this.status = data.status || "";
    this.data = (data.data || []).map(
      (results: any) => new TopDestinationCardItemClassInterface(results),
    );
  }
}
